import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export const Textarea = forwardRef<
  HTMLTextAreaElement,
  TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, style, ...props }, ref) => (
  <textarea
    ref={ref}
    style={{
      minHeight: 80,
      padding: '8px 12px',
      borderRadius: 6,
      border: '1px solid #cbd5e1',
      background: '#fff',
      fontSize: 14,
      fontFamily: 'inherit',
      resize: 'vertical',
      ...style,
    }}
    className={cn('textarea', className)}
    {...props}
  />
));
Textarea.displayName = 'Textarea';